import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

export default createPerformableConfig(
  'neighborhood-amenity-video',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
    }),
  },
  {
    name: 'Neighborhood Amenity Highlight Video',
    short:
      "This video is ideal for listings in areas where amenities are a major selling point. The video showcases the lifestyle and convenience surrounding a property by featuring the neighborhood's most attractive amenities such as pools, parks, walking trails, and clubhouses. Price includes up to three separate locations.",
    tenant: TenantId.TWIST_TOURS,
    color: '#2F6F8F',
    images: [],
  },
);
